<template>
  <div class="flex flex-col bg-white min-h-screen">
    <page-header :hide_navbar="hide_navbar"></page-header>
    <!-- <discount-band :hide_navbar="hide_navbar"></discount-band> -->
    <blogs></blogs>
    <fixed-contact-us-pop-up></fixed-contact-us-pop-up>
  </div>
</template>
<script>
import PageHeader from "./components/header.vue";
import Blogs from "./blogs/blogs.vue";
import FixedContactUsPopUp from "./components/fixed_contact_us_pop_up.vue";
import DiscountBand from "./components/discount_band.vue";

export default {
  name: "public_articles",
  props: {
    hide_navbar: String,
  },
  components: { PageHeader, Blogs, FixedContactUsPopUp, DiscountBand},
  data() {
    return {  
    };
  },
}
</script>
<style lang="scss" scoped>
.x {
    color: red
}
</style>